import { createReducer, on } from '@ngrx/store';
import * as BusLineStopActions from '../../actions/master-data/bus-line-stops.actions';
import { BusLineStopState } from '../../states/master-data/bus-line-stop.state';

export const initialState: BusLineStopState = {loading: false, busLineStops: []};

export const busLineStopReducer = createReducer(
    initialState,
    on(BusLineStopActions.loadBusLineStops, (state) => ({ ...state, loading: true })),
    on(BusLineStopActions.loadBusLineStopsSuccess, (state, {busLineStops}) => ({ ...state, loading: false, busLineStops })),
    on(BusLineStopActions.addBusLineStop, (state, {busLineStop}) => ({...state, busLineStops: [...state.busLineStops, busLineStop]})),
    on(BusLineStopActions.updateBusLineStop, (state, {busLineStop}) => ({...state, busLineStops: state.busLineStops.map(r => r.id === busLineStop.id ? busLineStop : r)})),
    on(BusLineStopActions.deleteBusLineStop, (state, {id}) => ({...state, busLineStops: state.busLineStops.filter(r => r.id.toString() !== id)})),
);